module.exports = __webpack_public_path__ + "static/media/slide-onogate.85e4536c.png";